// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2JcU3","error":"Textarea_error__hqTLK","readonly":"Textarea_readonly__3DWSj","disabled":"Textarea_disabled__12GGh"};